'use client';

import React from 'react';


const stageData = [
  { name: 'Met at Event', value: 8, fill: '#059669', total: 247 },
  { name: 'Mtg Confirmed', value: 18, fill: '#10b981', total: 247 },
  { name: 'Mtg Requested', value: 28, fill: '#f59e0b', total: 247 },
  { name: 'TL Shared', value: 41, fill: '#8b5cf6', total: 247 },
  { name: 'Intro Sent', value: 61, fill: '#6366f1', total: 247 },
  { name: 'Connected', value: 83, fill: '#0ea5e9', total: 247 },
];

const stageRows = [
  { id: 'sr-new', label: 'New Lead', count: 34, pct: 14, color: 'bg-slate-300' },
  { id: 'sr-identified', label: 'Identified', count: 24, pct: 10, color: 'bg-blue-300' },
  { id: 'sr-researching', label: 'Researching', count: 18, pct: 7, color: 'bg-violet-300' },
  { id: 'sr-li-req', label: 'LinkedIn Requested', count: 51, pct: 21, color: 'bg-sky-400' },
  { id: 'sr-li-conn', label: 'LinkedIn Connected', count: 32, pct: 13, color: 'bg-cyan-400' },
  { id: 'sr-intro', label: 'Intro Sent', count: 20, pct: 8, color: 'bg-indigo-400' },
  { id: 'sr-tl', label: 'TL Shared', count: 16, pct: 6, color: 'bg-purple-400' },
  { id: 'sr-mtg-req', label: 'Meeting Requested', count: 10, pct: 4, color: 'bg-amber-400' },
  { id: 'sr-mtg-conf', label: 'Meeting Confirmed', count: 18, pct: 7, color: 'bg-emerald-400' },
  { id: 'sr-met', label: 'Met at Event', count: 8, pct: 3, color: 'bg-green-500' },
  { id: 'sr-followup', label: 'Follow-up Sent', count: 5, pct: 2, color: 'bg-teal-400' },
  { id: 'sr-opp', label: 'Opportunity Created', count: 6, pct: 2, color: 'bg-orange-400' },
  { id: 'sr-closed', label: 'Closed / No Response', count: 5, pct: 2, color: 'bg-red-300' },
];

export default function PipelineStageBreakdown() {
  return (
    <div className="bg-white rounded-xl border border-border shadow-card p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-sm font-semibold text-foreground">Pipeline Stage Breakdown</h2>
          <p className="text-xs text-muted-foreground mt-0.5">All 247 contacts distributed by current stage</p>
        </div>
      </div>
      <div className="space-y-2">
        {stageRows?.map((row) => (
          <div key={row?.id} className="flex items-center gap-3">
            <div className="w-36 shrink-0">
              <p className="text-xs text-foreground truncate">{row?.label}</p>
            </div>
            <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
              <div
                className={`h-full rounded-full ${row?.color} transition-all duration-500`}
                style={{ width: `${row?.pct * 4}%` }}
              />
            </div>
            <div className="w-14 text-right">
              <span className="text-xs font-mono font-semibold text-foreground">{row?.count}</span>
              <span className="text-[10px] text-muted-foreground ml-1">({row?.pct}%)</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}